import React from 'react';
import { FiPhone, FiMail, FiInstagram, FiMapPin } from 'react-icons/fi';
import styles from './Footer.module.css';

const serviceLinks = [
  'Renovations & Repairs', 'Framing', 'Cladding & Siding',
  'Soffit & Flashing', 'Rainscreen & Waterproofing',
  'Hardie Board & Cement Board', 'Stucco Repairs', 'Natural Stone', 'Finishing Carpentry',
];

const nav = [
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Why Us', href: '#whyus' },
  { label: 'Projects', href: '#projects' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  const go = (e, href) => { e.preventDefault(); document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' }); };

  return (
    <footer className={styles.footer}>
      <div className={styles.top}>
        <div className={styles.brand}>
          <div className={styles.logoRow}>
            <div className={styles.logoMark}><span>AS</span></div>
            <div>
              <span className={styles.logoMain}>AussieSpec</span>
              <span className={styles.logoSub}>Structures</span>
            </div>
          </div>
          <p className={styles.tagline}>
            Expert construction, renovation and building envelope services across the Lower Mainland, BC.
          </p>
          <div className={styles.contacts}>
            <a href="tel:+17789912001" className={styles.contact}><FiPhone size={13}/> (778) 991-2001</a>
            <a href="mailto:aussiespec.structures@gmail.com" className={styles.contact}><FiMail size={13}/> aussiespec.structures@gmail.com</a>
            <a href="https://instagram.com/aussiespec.structures" target="_blank" rel="noreferrer" className={styles.contact}><FiInstagram size={13}/> @aussiespec.structures</a>
            <span className={styles.contact}><FiMapPin size={13}/> Vancouver & Lower Mainland, BC</span>
          </div>
          <div className={styles.incTag}>
            <span>BC Incorporated · BC1585120</span>
          </div>
        </div>

        <div className={styles.col}>
          <h4 className={styles.colTitle}>Navigate</h4>
          <ul className={styles.colLinks}>
            {nav.map(l => <li key={l.label}><a href={l.href} onClick={e => go(e, l.href)}>{l.label}</a></li>)}
          </ul>
        </div>

        <div className={styles.col}>
          <h4 className={styles.colTitle}>Services</h4>
          <ul className={styles.colLinks}>
            {serviceLinks.map(s => <li key={s}><a href="#services" onClick={e => go(e, '#services')}>{s}</a></li>)}
          </ul>
        </div>

        <div className={styles.col}>
          <h4 className={styles.colTitle}>Get Started</h4>
          <p className={styles.colText}>Free on-site estimates. No pressure. Just honest advice and quality work.</p>
          <a href="#contact" className={styles.footerCta} onClick={e => go(e, '#contact')}>
            Request Free Quote
          </a>
          <div className={styles.hours}>
            <span className={styles.hoursTitle}>Business Hours</span>
            <span>Mon – Sat: 7:00 AM – 6:00 PM</span>
            {/* TODO: Confirm hours with Enes */}
          </div>
        </div>
      </div>

      <div className={styles.bottom}>
        <p className={styles.copy}>© {new Date().getFullYear()} AussieSpec Structures · BC1585120. All rights reserved.</p>
        <p className={styles.built}>Vancouver, BC, Canada 🇨🇦</p>
      </div>
    </footer>
  );
}
